<template>
  <form
    id="search"
    name="search"
    class="search-form"
    @submit.prevent="onSearch"
  >
    <div class="search-form__wrapper">
      <input
        v-show="focusedInput"
        ref="inputSearchRef"
        v-model="inputValue"
        type="text"
        class="search-form__input"
        @blur="onBlur"
      />
      <Typewriter
        v-show="!focusedInput"
        :key="langStore.language.name"
        class="search-form__input typewriter"
        :strings="typewriterPrompt"
        @click="focusInput"
      />
      <div
        v-show="hasValue"
        class="search-form__clear"
        @click.prevent="onClear"
      >
        <img src="~~/assets/icons/cross.svg" alt="clear search value" />
      </div>
      <button type="submit" class="button-primary" :aria-label="_T('@Search')">
        <span class="button-primary__caption">
          {{ _T("@Search") }}
        </span>
        <span class="button-primary__icon">
          <img src="~~/assets/icons/search-white.svg" :alt="_T('@Search')" />
        </span>
      </button>
    </div>
  </form>
</template>

<script setup>
import { useLanguageStore } from "~/store/languageStore.js";
import Typewriter from "~/modules/shared/typewriter/Typewriter.vue";

const inputValue = ref("");
const inputSearchRef = ref(null);
const focusedInput = ref(false);
const langStore = useLanguageStore();

const typewriterPrompt = computed(() => {
  const prompts = [
    {
      ru: "Аккумулятор",
      uk: "Акумулятор",
    },
    {
      ru: "ИБП",
      uk: "ДБЖ",
    },
    {
      ru: "Стабилизатор",
      uk: "Стабілізатор",
    },
    {
      ru: "Autonomic",
      uk: "Autonomic",
    },
    {
      ru: "Альтернативная энергетика",
      uk: "Альтернативна енергетика",
    },
  ];

  return prompts.map((prompt) => getLocalizedName(prompt));
});

const hasValue = computed(() => {
  return 0 !== inputValue.value.trim().length;
});

const focusInput = async () => {
  focusedInput.value = true;

  await nextTick();
  inputSearchRef.value.focus();
};

const onClear = () => {
  inputValue.value = "";
  focusInput();
};

const onBlur = () => {
  if (!hasValue.value) {
    focusedInput.value = false;
  }
};

const onSearch = () => {
  if (hasValue.value) {
    return navigateTo({
      name: getLocalizedRouteName("search"),
      query: { searchQuery: inputValue.value.trim() },
    });
  }
};
</script>

<style lang="scss" scoped>
.search-form {
  max-width: 700px;
  width: 100%;

  background-color: white;
  border-radius: 30px;

  overflow: hidden;
  white-space: nowrap;

  &__wrapper {
    width: 100%;

    @include flex-container(row, center, center);
  }

  &__input {
    width: 100%;

    @include font();
    letter-spacing: 0.02em;

    padding: 8px 16px;

    cursor: text;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;

      margin: 0;
    }

    &::placeholder {
      @include font();
    }

    &.typewriter {
      color: var(--color-sky-darker);
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  &__clear {
    @include flex-container(row, center, center);

    @include fixedHW(40px);

    cursor: pointer;
  }
}

.button-primary {
  width: max-content;

  line-height: 22px;

  @include bigMobile {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

    border: none;

    padding-inline: 8px;
  }

  &__caption {
    @include bigMobile {
      display: none;
    }
  }

  &__icon {
    @include flex-container(row, center, center);

    @include fixedHW(24px);
  }
}
</style>
